'use client'
import { Button } from '@/core/ui/atoms/button'
import { useTranslations } from 'next-intl'
import { PaymentStrategy } from './type'

const Fragment: React.FC<{
  children: React.ReactNode
}> = ({ children }) => <>{children}</>

export const useAskPaymentStrategy: PaymentStrategy = ({
  isAskForPaymentPending,
}) => {
  const t = useTranslations()
  return {
    Button: (
      <Button
        type='submit'
        loading={isAskForPaymentPending}
        className='h-11 w-56 self-end'
      >
        {t('actions.pay&book')}
      </Button>
    ),
    Form: null,
    Provider: Fragment,
  }
}
